<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    font-family: "微软雅黑";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
    background: white;
    font-size: 14px;
  }
  *{
    margin:0;
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue